// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.6
//   protoc               unknown
// source: photon/imessage/v1/location_service.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import type { CallContext, CallOptions } from "nice-grpc-common";
import { SharedFriendLocation, SharedFriendLocationUpdated } from "./location_types.js";
import { Heartbeat } from "./streaming.js";

export const protobufPackage = "photon.imessage.v1";

export interface ListSharedFriendLocationsRequest {
}

export interface ListSharedFriendLocationsResponse {
  locations: SharedFriendLocation[];
}

/**
 * Returns the current shared location for one address.
 *
 * Errors:
 *   INVALID_ARGUMENT  malformed address
 *   NOT_FOUND         address is valid but not currently sharing a location
 */
export interface GetSharedFriendLocationRequest {
  address: string;
}

export interface GetSharedFriendLocationResponse {
  location: SharedFriendLocation | undefined;
}

/**
 * Sends a visible Find My request card to `address` in `chat_guid`.
 * `address` must be a participant in the chat.
 *
 * Errors:
 *   INVALID_ARGUMENT  malformed address/chat_guid, or address is not in chat
 *   NOT_FOUND         chat is not visible to the current account
 */
export interface RequestFriendLocationSharingRequest {
  chatGuid: string;
  address: string;
  clientMessageId?: string | undefined;
}

export interface RequestFriendLocationSharingResponse {
  address: string;
  status: string;
  reason?: string | undefined;
  messageGuid?: string | undefined;
}

/**
 * Absent `address` = watch every shared location update. Present
 * `address` = watch updates for one address only.
 */
export interface WatchSharedFriendLocationsRequest {
  address?: string | undefined;
}

export interface WatchSharedFriendLocationsResponse {
  locationUpdated?: SharedFriendLocationUpdated | undefined;
  heartbeat?: Heartbeat | undefined;
}

function createBaseListSharedFriendLocationsRequest(): ListSharedFriendLocationsRequest {
  return {};
}

export const ListSharedFriendLocationsRequest: MessageFns<ListSharedFriendLocationsRequest> = {
  encode(_: ListSharedFriendLocationsRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ListSharedFriendLocationsRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseListSharedFriendLocationsRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): ListSharedFriendLocationsRequest {
    return {};
  },

  toJSON(_: ListSharedFriendLocationsRequest): unknown {
    const obj: any = {};
    return obj;
  },

  create(base?: DeepPartial<ListSharedFriendLocationsRequest>): ListSharedFriendLocationsRequest {
    return ListSharedFriendLocationsRequest.fromPartial(base ?? {});
  },
  fromPartial(_: DeepPartial<ListSharedFriendLocationsRequest>): ListSharedFriendLocationsRequest {
    const message = createBaseListSharedFriendLocationsRequest();
    return message;
  },
};

function createBaseListSharedFriendLocationsResponse(): ListSharedFriendLocationsResponse {
  return { locations: [] };
}

export const ListSharedFriendLocationsResponse: MessageFns<ListSharedFriendLocationsResponse> = {
  encode(message: ListSharedFriendLocationsResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.locations) {
      SharedFriendLocation.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ListSharedFriendLocationsResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseListSharedFriendLocationsResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.locations.push(SharedFriendLocation.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ListSharedFriendLocationsResponse {
    return {
      locations: globalThis.Array.isArray(object?.locations)
        ? object.locations.map((e: any) => SharedFriendLocation.fromJSON(e))
        : [],
    };
  },

  toJSON(message: ListSharedFriendLocationsResponse): unknown {
    const obj: any = {};
    if (message.locations?.length) {
      obj.locations = message.locations.map((e) => SharedFriendLocation.toJSON(e));
    }
    return obj;
  },

  create(base?: DeepPartial<ListSharedFriendLocationsResponse>): ListSharedFriendLocationsResponse {
    return ListSharedFriendLocationsResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<ListSharedFriendLocationsResponse>): ListSharedFriendLocationsResponse {
    const message = createBaseListSharedFriendLocationsResponse();
    message.locations = object.locations?.map((e) => SharedFriendLocation.fromPartial(e)) || [];
    return message;
  },
};

function createBaseGetSharedFriendLocationRequest(): GetSharedFriendLocationRequest {
  return { address: "" };
}

export const GetSharedFriendLocationRequest: MessageFns<GetSharedFriendLocationRequest> = {
  encode(message: GetSharedFriendLocationRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.address !== "") {
      writer.uint32(10).string(message.address);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetSharedFriendLocationRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetSharedFriendLocationRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.address = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetSharedFriendLocationRequest {
    return { address: isSet(object.address) ? globalThis.String(object.address) : "" };
  },

  toJSON(message: GetSharedFriendLocationRequest): unknown {
    const obj: any = {};
    if (message.address !== "") {
      obj.address = message.address;
    }
    return obj;
  },

  create(base?: DeepPartial<GetSharedFriendLocationRequest>): GetSharedFriendLocationRequest {
    return GetSharedFriendLocationRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<GetSharedFriendLocationRequest>): GetSharedFriendLocationRequest {
    const message = createBaseGetSharedFriendLocationRequest();
    message.address = object.address ?? "";
    return message;
  },
};

function createBaseGetSharedFriendLocationResponse(): GetSharedFriendLocationResponse {
  return { location: undefined };
}

export const GetSharedFriendLocationResponse: MessageFns<GetSharedFriendLocationResponse> = {
  encode(message: GetSharedFriendLocationResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.location !== undefined) {
      SharedFriendLocation.encode(message.location, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetSharedFriendLocationResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetSharedFriendLocationResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.location = SharedFriendLocation.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetSharedFriendLocationResponse {
    return { location: isSet(object.location) ? SharedFriendLocation.fromJSON(object.location) : undefined };
  },

  toJSON(message: GetSharedFriendLocationResponse): unknown {
    const obj: any = {};
    if (message.location !== undefined) {
      obj.location = SharedFriendLocation.toJSON(message.location);
    }
    return obj;
  },

  create(base?: DeepPartial<GetSharedFriendLocationResponse>): GetSharedFriendLocationResponse {
    return GetSharedFriendLocationResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<GetSharedFriendLocationResponse>): GetSharedFriendLocationResponse {
    const message = createBaseGetSharedFriendLocationResponse();
    message.location = (object.location !== undefined && object.location !== null)
      ? SharedFriendLocation.fromPartial(object.location)
      : undefined;
    return message;
  },
};

function createBaseRequestFriendLocationSharingRequest(): RequestFriendLocationSharingRequest {
  return { chatGuid: "", address: "", clientMessageId: undefined };
}

export const RequestFriendLocationSharingRequest: MessageFns<RequestFriendLocationSharingRequest> = {
  encode(message: RequestFriendLocationSharingRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.chatGuid !== "") {
      writer.uint32(10).string(message.chatGuid);
    }
    if (message.address !== "") {
      writer.uint32(18).string(message.address);
    }
    if (message.clientMessageId !== undefined) {
      writer.uint32(802).string(message.clientMessageId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RequestFriendLocationSharingRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRequestFriendLocationSharingRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.chatGuid = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.address = reader.string();
          continue;
        }
        case 100: {
          if (tag !== 802) {
            break;
          }

          message.clientMessageId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RequestFriendLocationSharingRequest {
    return {
      chatGuid: isSet(object.chatGuid)
        ? globalThis.String(object.chatGuid)
        : isSet(object.chat_guid)
        ? globalThis.String(object.chat_guid)
        : "",
      address: isSet(object.address) ? globalThis.String(object.address) : "",
      clientMessageId: isSet(object.clientMessageId)
        ? globalThis.String(object.clientMessageId)
        : isSet(object.client_message_id)
        ? globalThis.String(object.client_message_id)
        : undefined,
    };
  },

  toJSON(message: RequestFriendLocationSharingRequest): unknown {
    const obj: any = {};
    if (message.chatGuid !== "") {
      obj.chatGuid = message.chatGuid;
    }
    if (message.address !== "") {
      obj.address = message.address;
    }
    if (message.clientMessageId !== undefined) {
      obj.clientMessageId = message.clientMessageId;
    }
    return obj;
  },

  create(base?: DeepPartial<RequestFriendLocationSharingRequest>): RequestFriendLocationSharingRequest {
    return RequestFriendLocationSharingRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<RequestFriendLocationSharingRequest>): RequestFriendLocationSharingRequest {
    const message = createBaseRequestFriendLocationSharingRequest();
    message.chatGuid = object.chatGuid ?? "";
    message.address = object.address ?? "";
    message.clientMessageId = object.clientMessageId ?? undefined;
    return message;
  },
};

function createBaseRequestFriendLocationSharingResponse(): RequestFriendLocationSharingResponse {
  return { address: "", status: "", reason: undefined, messageGuid: undefined };
}

export const RequestFriendLocationSharingResponse: MessageFns<RequestFriendLocationSharingResponse> = {
  encode(message: RequestFriendLocationSharingResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.address !== "") {
      writer.uint32(10).string(message.address);
    }
    if (message.status !== "") {
      writer.uint32(18).string(message.status);
    }
    if (message.reason !== undefined) {
      writer.uint32(26).string(message.reason);
    }
    if (message.messageGuid !== undefined) {
      writer.uint32(34).string(message.messageGuid);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RequestFriendLocationSharingResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRequestFriendLocationSharingResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.address = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.status = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.reason = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.messageGuid = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RequestFriendLocationSharingResponse {
    return {
      address: isSet(object.address) ? globalThis.String(object.address) : "",
      status: isSet(object.status) ? globalThis.String(object.status) : "",
      reason: isSet(object.reason) ? globalThis.String(object.reason) : undefined,
      messageGuid: isSet(object.messageGuid)
        ? globalThis.String(object.messageGuid)
        : isSet(object.message_guid)
        ? globalThis.String(object.message_guid)
        : undefined,
    };
  },

  toJSON(message: RequestFriendLocationSharingResponse): unknown {
    const obj: any = {};
    if (message.address !== "") {
      obj.address = message.address;
    }
    if (message.status !== "") {
      obj.status = message.status;
    }
    if (message.reason !== undefined) {
      obj.reason = message.reason;
    }
    if (message.messageGuid !== undefined) {
      obj.messageGuid = message.messageGuid;
    }
    return obj;
  },

  create(base?: DeepPartial<RequestFriendLocationSharingResponse>): RequestFriendLocationSharingResponse {
    return RequestFriendLocationSharingResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<RequestFriendLocationSharingResponse>): RequestFriendLocationSharingResponse {
    const message = createBaseRequestFriendLocationSharingResponse();
    message.address = object.address ?? "";
    message.status = object.status ?? "";
    message.reason = object.reason ?? undefined;
    message.messageGuid = object.messageGuid ?? undefined;
    return message;
  },
};

function createBaseWatchSharedFriendLocationsRequest(): WatchSharedFriendLocationsRequest {
  return { address: undefined };
}

export const WatchSharedFriendLocationsRequest: MessageFns<WatchSharedFriendLocationsRequest> = {
  encode(message: WatchSharedFriendLocationsRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.address !== undefined) {
      writer.uint32(10).string(message.address);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): WatchSharedFriendLocationsRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseWatchSharedFriendLocationsRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.address = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): WatchSharedFriendLocationsRequest {
    return { address: isSet(object.address) ? globalThis.String(object.address) : undefined };
  },

  toJSON(message: WatchSharedFriendLocationsRequest): unknown {
    const obj: any = {};
    if (message.address !== undefined) {
      obj.address = message.address;
    }
    return obj;
  },

  create(base?: DeepPartial<WatchSharedFriendLocationsRequest>): WatchSharedFriendLocationsRequest {
    return WatchSharedFriendLocationsRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<WatchSharedFriendLocationsRequest>): WatchSharedFriendLocationsRequest {
    const message = createBaseWatchSharedFriendLocationsRequest();
    message.address = object.address ?? undefined;
    return message;
  },
};

function createBaseWatchSharedFriendLocationsResponse(): WatchSharedFriendLocationsResponse {
  return { locationUpdated: undefined, heartbeat: undefined };
}

export const WatchSharedFriendLocationsResponse: MessageFns<WatchSharedFriendLocationsResponse> = {
  encode(message: WatchSharedFriendLocationsResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.locationUpdated !== undefined) {
      SharedFriendLocationUpdated.encode(message.locationUpdated, writer.uint32(82).fork()).join();
    }
    if (message.heartbeat !== undefined) {
      Heartbeat.encode(message.heartbeat, writer.uint32(794).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): WatchSharedFriendLocationsResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseWatchSharedFriendLocationsResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.locationUpdated = SharedFriendLocationUpdated.decode(reader, reader.uint32());
          continue;
        }
        case 99: {
          if (tag !== 794) {
            break;
          }

          message.heartbeat = Heartbeat.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): WatchSharedFriendLocationsResponse {
    return {
      locationUpdated: isSet(object.locationUpdated)
        ? SharedFriendLocationUpdated.fromJSON(object.locationUpdated)
        : isSet(object.location_updated)
        ? SharedFriendLocationUpdated.fromJSON(object.location_updated)
        : undefined,
      heartbeat: isSet(object.heartbeat) ? Heartbeat.fromJSON(object.heartbeat) : undefined,
    };
  },

  toJSON(message: WatchSharedFriendLocationsResponse): unknown {
    const obj: any = {};
    if (message.locationUpdated !== undefined) {
      obj.locationUpdated = SharedFriendLocationUpdated.toJSON(message.locationUpdated);
    }
    if (message.heartbeat !== undefined) {
      obj.heartbeat = Heartbeat.toJSON(message.heartbeat);
    }
    return obj;
  },

  create(base?: DeepPartial<WatchSharedFriendLocationsResponse>): WatchSharedFriendLocationsResponse {
    return WatchSharedFriendLocationsResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<WatchSharedFriendLocationsResponse>): WatchSharedFriendLocationsResponse {
    const message = createBaseWatchSharedFriendLocationsResponse();
    message.locationUpdated = (object.locationUpdated !== undefined && object.locationUpdated !== null)
      ? SharedFriendLocationUpdated.fromPartial(object.locationUpdated)
      : undefined;
    message.heartbeat = (object.heartbeat !== undefined && object.heartbeat !== null)
      ? Heartbeat.fromPartial(object.heartbeat)
      : undefined;
    return message;
  },
};

/**
 * Find My friend-location queries and live updates.
 * Reads issue one-shot source queries; the watch stream forwards pushed
 * observations and is not server-polled on a timer.
 */
export type LocationServiceDefinition = typeof LocationServiceDefinition;
export const LocationServiceDefinition = {
  name: "LocationService",
  fullName: "photon.imessage.v1.LocationService",
  methods: {
    listSharedFriendLocations: {
      name: "ListSharedFriendLocations",
      requestType: ListSharedFriendLocationsRequest as typeof ListSharedFriendLocationsRequest,
      requestStream: false,
      responseType: ListSharedFriendLocationsResponse as typeof ListSharedFriendLocationsResponse,
      responseStream: false,
      options: {},
    },
    getSharedFriendLocation: {
      name: "GetSharedFriendLocation",
      requestType: GetSharedFriendLocationRequest as typeof GetSharedFriendLocationRequest,
      requestStream: false,
      responseType: GetSharedFriendLocationResponse as typeof GetSharedFriendLocationResponse,
      responseStream: false,
      options: {},
    },
    requestFriendLocationSharing: {
      name: "RequestFriendLocationSharing",
      requestType: RequestFriendLocationSharingRequest as typeof RequestFriendLocationSharingRequest,
      requestStream: false,
      responseType: RequestFriendLocationSharingResponse as typeof RequestFriendLocationSharingResponse,
      responseStream: false,
      options: {},
    },
    watchSharedFriendLocations: {
      name: "WatchSharedFriendLocations",
      requestType: WatchSharedFriendLocationsRequest as typeof WatchSharedFriendLocationsRequest,
      requestStream: false,
      responseType: WatchSharedFriendLocationsResponse as typeof WatchSharedFriendLocationsResponse,
      responseStream: true,
      options: {},
    },
  },
} as const;

export interface LocationServiceImplementation<CallContextExt = {}> {
  listSharedFriendLocations(
    request: ListSharedFriendLocationsRequest,
    context: CallContext & CallContextExt,
  ): Promise<DeepPartial<ListSharedFriendLocationsResponse>>;
  getSharedFriendLocation(
    request: GetSharedFriendLocationRequest,
    context: CallContext & CallContextExt,
  ): Promise<DeepPartial<GetSharedFriendLocationResponse>>;
  requestFriendLocationSharing(
    request: RequestFriendLocationSharingRequest,
    context: CallContext & CallContextExt,
  ): Promise<DeepPartial<RequestFriendLocationSharingResponse>>;
  watchSharedFriendLocations(
    request: WatchSharedFriendLocationsRequest,
    context: CallContext & CallContextExt,
  ): ServerStreamingMethodResult<DeepPartial<WatchSharedFriendLocationsResponse>>;
}

export interface LocationServiceClient<CallOptionsExt = {}> {
  listSharedFriendLocations(
    request: DeepPartial<ListSharedFriendLocationsRequest>,
    options?: CallOptions & CallOptionsExt,
  ): Promise<ListSharedFriendLocationsResponse>;
  getSharedFriendLocation(
    request: DeepPartial<GetSharedFriendLocationRequest>,
    options?: CallOptions & CallOptionsExt,
  ): Promise<GetSharedFriendLocationResponse>;
  requestFriendLocationSharing(
    request: DeepPartial<RequestFriendLocationSharingRequest>,
    options?: CallOptions & CallOptionsExt,
  ): Promise<RequestFriendLocationSharingResponse>;
  watchSharedFriendLocations(
    request: DeepPartial<WatchSharedFriendLocationsRequest>,
    options?: CallOptions & CallOptionsExt,
  ): AsyncIterable<WatchSharedFriendLocationsResponse>;
}

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export type ServerStreamingMethodResult<Response> = { [Symbol.asyncIterator](): AsyncIterator<Response, void> };

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create(base?: DeepPartial<T>): T;
  fromPartial(object: DeepPartial<T>): T;
}
